<div id="appHeader">
  <app-header></app-header>
</div>
<div class="custom-all-page-min-height">
  <router-outlet></router-outlet>
</div>
<div id="appFooter">
  <app-footer></app-footer>
</div>
